
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  watch,
} from "vue";
import { useStore } from "vuex";
import { displayType } from "@/types/SurveyInfo";

export default defineComponent({
  name: "CSIBlock",

  props: {
    text: String,
    currentLang: String,
    csiAnswers: Array,
    csiScale: String,
    index: Number,
    type: {
      type: String as PropType<displayType | undefined>,
      required: false,
    },
  },
  emits: ["answersFields"],

  setup(props, { emit }) {
    const store = useStore();
    const togglerBtn = ref<boolean>(false);
    const displayType = store.getters["GET_DISPLAY_TYPE"]();
    const crit = ref([{}]);
    const criterialsArray = ref([{}]);
    const booleanPointScore = ref([
      { name: "Да", score: 1 },
      { name: "Нет", score: 0 },
    ]);
    const csiAnswers = computed(() => props.csiAnswers);
    const curLang = computed(() => props.currentLang);

    watch(
      () => curLang.value,
      () => {
        uploadCsi();
      }
    );

    watch(
      () => csiAnswers.value,
      (v: any) => {
        if (displayType === "ONE") {
          uploadCsi();
        }
      }
    );

    onMounted(() => {
      uploadCsi();
    });

    const changeSelect = () => {
      togglerBtn.value = crit.value.every((item: any) => {
        return !!item.criterias.every((i: any) => i.score !== "");
      });
      if (togglerBtn.value) {
        emit(
          "answersFields",
          // i (index)
          props.index,
          // value obj
          {
            value: crit.value,
          }
        );
      }
    };

    const uploadCsi = () => {
      crit.value = [];
      csiAnswers.value?.forEach((answer: any) => {
        criterialsArray.value = [];
        answer.criterias.forEach((criterial: any) => {
          criterialsArray.value.push({
            id: criterial.csiCriteriaId,
            name:
              props.currentLang === "RU"
                ? criterial.criteriaNameRu
                : criterial.criteriaNameKk,
            score: "",
          });
        });
        crit.value.push({
          csiParamId: answer.csiParamId,
          paramName:
            props.currentLang === "RU"
              ? answer.paramNameRu
              : answer.paramNameKk,
          scale: props.csiScale,
          criterias: criterialsArray.value,
        });
      });
      changeSelect();
    };

    return {
      booleanPointScore,
      crit,
      togglerBtn,
      changeSelect,
      uploadCsi,
      curLang,
      displayType,
    };
  },
});
